import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context.tsx';
import { colors } from '../primitives/colors/index.tsx';
import Link from '../primitives/link';
import SplitHero from '../sections/SplitHero';

const FranchiseContactHero = ({ data }) => {
    const franchiseData = useMicrosite();

    const {
        name,
        address,
        activeMarkets,
        addressHidden,
    } = franchiseData?.franchise || {};

    const { address: line1, addressExt: line2, city, state, postalCode } = address;

    return (
        <SplitHero
            data={{ heading: name, image: data.image }}
        >
            <div css={styles.wrap}>
                {!addressHidden && (
                    <address css={styles.marginTop}>
                        <h4 css={styles.heading}>Address</h4>
                        {!!line1 && (
                            <>
                                {line1}
                                <br />
                            </>
                        )}
                        {!!line2 && (
                            <>
                                {line2}
                                <br />
                            </>
                        )}
                        {city}
                        ,
                        {' '}
                        {state}
                        {' '}
                        {postalCode}
                    </address>
                )}
                {!!activeMarkets && !!activeMarkets.length > 0 && (
                    <div css={styles.marginTop}>
                        <h4 css={styles.heading}>Service Area</h4>

                        <div css={styles.serviceArea}>
                            {activeMarkets.map((activeMarket, idx) => {
                                const place = `${activeMarket.city}, ${activeMarket.state}`;
                                if (activeMarket.link) {
                                    return (
                                        <span>
                                            <Link
                                                css={{
                                                    textDecoration: 'underline',
                                                    transition: '0.3s',
                                                    '&:hover': {
                                                        color: colors.primaryGreen,
                                                    },
                                                }}
                                                to={(activeMarket.link || '')}
                                            >
                                                {place}
                                            </Link>
                                            {idx !== activeMarkets.length - 1 && ' | '}
                                        </span>
                                    );
                                }

                                return (
                                    <span>
                                        {place}
                                        {idx !== activeMarkets.length - 1 && ' | '}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                )}

            </div>
        </SplitHero>
    );
};

const styles = {
    wrap: { marginTop: '1.25rem', color: colors.grey800 },
    marginTop: { marginTop: '1rem' },
    heading: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        fontWeight: 500,
        color: colors.primaryOrange,
        '@media (min-width: 1024px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    serviceArea: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        '@media (min-width: 1024px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    hyperlocalLink: {
        textDecoration: 'underline',
        transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
        transitionDuration: '300ms',
        '&:hover': { color: '#059669' },
    },

};

export const query = graphql`
  fragment FranchiseContactHeroData on CmsPageBuilderBlocks {
    franchise_contact_hero { 
      image {
          filename
          title
          description
          url
          contentStackAsset(width: 1440)
        }
    }
  }
`;

export default FranchiseContactHero;
